import './Toast.scss'

export function Toast({ children, onClose }) {
  return <div className="Toast">{children}</div>
}
